// Canonical labels and colors for invoice statuses across the financeiro
// pages. Internal status values are persisted by the Asaas webhook handler
// in `Invoices.status` (5 buckets: paid, pending, overdue, refunded,
// canceled). Keep this file as the single source of truth so super-admin
// and customer-facing views stay consistent.

export const INVOICE_STATUS_LABELS = {
  paid: { label: "Pago", bg: "#e8f5e9", fg: "#2e7d32" },
  pending: { label: "Pendente", bg: "#fff8e1", fg: "#9e6b00" },
  overdue: { label: "Vencido", bg: "#ffebee", fg: "#c62828" },
  refunded: { label: "Reembolsado", bg: "#fce4ec", fg: "#ad1457" },
  canceled: { label: "Cancelado", bg: "#eceff1", fg: "#546e7a" }
};

export const getInvoiceStatusLabel = (status) =>
  INVOICE_STATUS_LABELS[status] || {
    label: status || "—",
    bg: "#eceff1",
    fg: "#546e7a"
  };

// Asaas billingType enum → friendly Portuguese label. Stored on
// Company.paymentFlow as the raw Asaas value after normalization.
export const PAYMENT_METHOD_LABELS = {
  CREDIT_CARD: "Cartão de Crédito",
  PIX: "PIX",
  BOLETO: "Boleto"
};

export const formatPaymentMethod = (paymentFlow, paymentMethod) => {
  if (paymentFlow && PAYMENT_METHOD_LABELS[paymentFlow]) {
    return PAYMENT_METHOD_LABELS[paymentFlow];
  }
  if (paymentFlow) return paymentFlow;
  if (paymentMethod) return paymentMethod;
  return "—";
};
